export const summary = (invoice) => ({
  style: "summary",
  layout: 'noBorders',
  table: {
      widths:["*", "auto", 'auto'],
      heights: 100,
      body: [[
              { text: "" },
              {
                  stack: [
                      { text: "Subtotal", style: "totalsLabel" },
                      { text: "GST", style: "totalsLabel" },
                      { text: "PST", style: "totalsLabel" },
                      { text: "Total", style: "grandTotalsLabel" }
                  ]
              },
              {
                  stack: [
                      { text: `$${Number(invoice.total).toFixed(2)}`, style: "totalsText" },
                      { text: `$${Number(invoice.gst).toFixed(2)}`, style: "totalsText" },
                      { text: `$${Number(invoice.pst).toFixed(2)}`, style: "totalsText" },
                      { text: `$${Number(invoice.grandTotal).toFixed(2)}`, style: "grandTotalsText" }
                  ]
              }
      ]]
  }
});



// WEBPACK FOOTER //
// ./src/store/generators/PDF/invoice/summary.js